import React from "react";

const InfinitePossibilities: React.FC = () => {
  return (
    <div className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 px-6">
        <div className="relative flex flex-col justify-center">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,200,150,0.25)_2px,transparent_2px)] bg-[size:18px_18px] opacity-60"></div>

          <div className="relative z-10 max-w-lg">
            <h2
              className="text-4xl md:text-5xl font-bold leading-tight 
              bg-gradient-to-r from-sky-400 to-teal-200 bg-clip-text text-transparent"
            >
              Unlocking the Potential of Advanced Battery Technologies
            </h2>

            <p className="text-gray-600 mt-6 leading-relaxed">
              At Devananta R&D, we work to expand the possibilities of energy
              storage through research, engineering excellence, and intelligent
              system design.
            </p>

            <p className="text-gray-600 mt-6 leading-relaxed">
              By integrating advanced battery technologies with data-driven
              control and monitoring systems, we develop solutions that are
              efficient, reliable, and adaptable across real-world applications
              supporting smarter, more resilient energy use.
            </p>
          </div>
        </div>

        <div className="relative w-full h-[520px] flex justify-center items-center">
          <div className="grid grid-cols-2 grid-rows-2 gap-3 w-[620px] h-[520px]">
            <div className="relative overflow-hidden shadow-md">
              <div
                className="absolute inset-0 bg-cover bg-no-repeat"
                style={{
                  backgroundImage: "url('/bgmain.jpg')",
                  backgroundPosition: "-20px -10px",
                  backgroundSize: "600px",
                }}
              ></div>
            </div>

            <div className="relative overflow-hidden shadow-md">
              <div
                className="absolute inset-0 bg-cover bg-no-repeat"
                style={{
                  backgroundImage: "url('/bgmain.jpg')",
                  backgroundPosition: "-300px -10px",
                  backgroundSize: "600px",
                }}
              ></div>
            </div>

            <div className="relative overflow-hidden shadow-md">
              <div
                className="absolute inset-0 bg-cover bg-no-repeat"
                style={{
                  backgroundImage: "url('/bgmain.jpg')",
                  backgroundPosition: "-20px -260px",
                  backgroundSize: "600px",
                }}
              ></div>
            </div>

            <div className="relative overflow-hidden shadow-md">
              <div
                className="absolute inset-0 bg-cover bg-no-repeat"
                style={{
                  backgroundImage: "url('/bgmain.jpg')",
                  backgroundPosition: "-300px -260px",
                  backgroundSize: "600px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfinitePossibilities;
